import { c as _c } from "react/compiler-runtime";
import { useGroupMembersMenuOptionsMobile } from "@pages/group-details/use-group-members-menu-options-mobile";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
import { sortMembers } from "@utils/member-utils";
/**
 * Mobile-specific view for members list.
 * Renders a virtualized list of members for the groups with selection, menu options, and bulk actions.
 */
export function GroupMembersMobileView(t0) {
  const $ = _c(10);
  const {
    group,
    members,
    bulkActionButtons,
    isLoading,
    sortBy
  } = t0;
  const menuItems = useGroupMembersMenuOptionsMobile();
  let t1;
  if ($[0] !== members || $[1] !== sortBy) {
    t1 = sortMembers(members, sortBy);
    $[0] = members;
    $[1] = sortBy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sortedMembers = t1;
  let t2;
  if ($[3] !== bulkActionButtons || $[4] !== group || $[5] !== isLoading || $[6] !== menuItems || $[7] !== sortBy || $[8] !== sortedMembers) {
    t2 = <MemberMobileList members={sortedMembers} isLoading={isLoading} bulkActionButtons={bulkActionButtons} tableSubject="group" menuItems={menuItems} group={group} sortBy={sortBy} />;
    $[3] = bulkActionButtons;
    $[4] = group;
    $[5] = isLoading;
    $[6] = menuItems;
    $[7] = sortBy;
    $[8] = sortedMembers;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}